import React from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  isLoading?: boolean;
  type?: 'confirmation' | 'notification';
}

const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message,
  isLoading = false,
  type = 'confirmation'
}) => {
  // Si es tipo notificación, personalizar el footer para mostrar solo el botón Cerrar
  const footerContent = type === 'notification' ? (
    <Button onClick={onClose} className="dark-button">
      Cerrar
    </Button>
  ) : null; // Para confirmation usamos los botones por defecto
  
  return (
    <ConfirmDialog 
      visible={isOpen}
      onHide={onClose}
      message={message}
      header={title}
      icon="pi pi-exclamation-triangle"
      acceptLabel={isLoading ? 'Procesando...' : 'Confirmar'}
      rejectLabel="Cancelar"
      acceptClassName="dark-button"
      rejectClassName="light-button"
      accept={onConfirm}
      reject={onClose}
      footer={footerContent}
    />
  );
};

export default Modal; 